import React from 'react';
import { Colgroup } from './colgroup';
import { getTableContainerWidth } from '@atlaskit/editor-common/node-width';
import { akEditorDefaultLayoutWidth } from '@atlaskit/editor-shared-styles';
export const Table = /*#__PURE__*/React.memo(({
  innerRef,
  isNumberColumnEnabled,
  columnWidths,
  layout,
  renderWidth,
  children,
  tableNode,
  rendererAppearance,
  isInsideOfBlockNode,
  isinsideMultiBodiedExtension
}) => {
  const tableWidth = tableNode ? getTableContainerWidth(tableNode) : akEditorDefaultLayoutWidth;
  return /*#__PURE__*/React.createElement("table", {
    "data-testid": "renderer-table",
    "data-number-column": isNumberColumnEnabled,
    "data-table-width": tableWidth,
    ref: innerRef
  }, /*#__PURE__*/React.createElement(Colgroup, {
    columnWidths: columnWidths,
    layout: layout,
    isNumberColumnEnabled: isNumberColumnEnabled,
    renderWidth: renderWidth,
    tableNode: tableNode,
    rendererAppearance: rendererAppearance,
    isInsideOfBlockNode: isInsideOfBlockNode,
    isinsideMultiBodiedExtension: isinsideMultiBodiedExtension
  }), /*#__PURE__*/React.createElement("tbody", null, children));
});